import Immutable from 'immutable';
import { DEVICE_INFO_UPDATED, LOG_RESULT, NEXT_VIDEO, SEND_RESULTS_SUCCEEDED, UPDATE_COMMENT, UPDATE_AGE_RANGE, UPDATE_HEARABILITY } from '../actions';
import { NUMBER_OF_VIDEOS } from "../../services/config";

let initialState = Immutable.fromJS({
    progress: 0,
    video1: 0,
    video2: 0,
    id: uuid(),
    device: null,
    comment: '',
    result: {},
    videos: [...Array(NUMBER_OF_VIDEOS).keys()].map(x => x + 1), // Steps are not 0-indexed
    ageRange: "",
    perceivedHearability: 0
});

function getRandomVideo() {
    // get one of the two alternatives
    return Math.floor(Math.random() * 2 + 1)
}

function getRandomIndexAndRemove(videos) {
    const randomItem = videos[Math.floor(Math.random() * videos.length)]
    const idx = videos.indexOf(randomItem)
    if (idx > - 1) {
        videos.splice(idx, 1)
    }
    console.log(videos)
    console.log(randomItem)
    return [videos, randomItem]
}

function uuid(a) {
    return a ? (a ^ (Math.random() * 16 >> a / 4)).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid)
}

function videotest(state = initialState, action) {
    switch (action.type) {
        case NEXT_VIDEO:
            const [videos, randomItem] = getRandomIndexAndRemove([...state.get('videos')])
            return state
                .set('progress', state.get('progress') + 1)
                .set('video1', randomItem + '_' + getRandomVideo())
                .set('video2', randomItem + '_' + getRandomVideo())
                .set('videos', videos)
        case SEND_RESULTS_SUCCEEDED:
            return state
                .set('progress', 999)
                .set('video', 0);
        case LOG_RESULT:
            return state.setIn(['result', `${state.get('video1')}::${state.get('video2')}`], action.payload);
        case UPDATE_COMMENT:
            return state.set('comment', action.payload);
        case UPDATE_AGE_RANGE:
            return state.set('ageRange', action.payload)
        case UPDATE_HEARABILITY:
            return state.set('perceivedHearability', action.payload)
        case DEVICE_INFO_UPDATED:
            return state.set('device', action.payload);
        default:
            return state;
    }
}

export default videotest;



// WEBPACK FOOTER //
// ./src/redux/reducers/videotest.js